import * as swcHelpers from '@swc/helpers';
import { QueryString } from '@grandvisionhq/utils';
import { unwrapResponse } from '../response.js';
import { acceptJson, postJson } from '../shared.js';

const getContactLenses = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/contactlenses/${request.variantGroup}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson)
        })));
    });
    return function getContactLenses(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();
const getContactLensBundles = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        const expands = [
            'masterVariant.prices[*].discounted.discount',
            'variants[*].prices[*].discounted.discount',
            'masterVariant.attributes[*].value',
            'productType', 
        ];
        const queryParams = QueryString.stringify({
            expand: expands.join('|'),
            filters: `variants.sku:"${request.sku}"`,
            solutions: 'true'
        }, true, true);
        return unwrapResponse((yield fetch(`${apiUrl}/?${queryParams}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson)
        })));
    });
    return function getContactLensBundles(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getContactLensBundles, getContactLenses };
//# sourceMappingURL=contactlenses.js.map
